import { Box, Text } from "grommet";
import { ReactComponent as Logo } from "../../assets/umc-utrecht-logo.svg";

export function SmallScreenMessage(): React.ReactElement {
  return (
    <Box align="center" justify="center" fill>
      <Box gap="medium" margin="large">
        <Box align="center">
          <Logo width="150" height="80" />
        </Box>
        <Text textAlign="center">Your screen width is too small to make proper use of this application.</Text>
        <Text textAlign="center" weight="bold" color="red">
          Open this page on a bigger screen to see our app in action.
        </Text>
      </Box>
    </Box>
  );
}
